// Helper para montar links de WhatsApp
const WA_NUMBER = (process.env.REACT_APP_WHATSAPP_NUMBER || "").replace(/\D/g, "");

export function buildWhatsappUrl(text) {
  const encoded = encodeURIComponent(text || "");
  return WA_NUMBER
    ? `https://wa.me/${WA_NUMBER}?text=${encoded}`
    : `https://wa.me/?text=${encoded}`;
}

export function openWhatsapp(text) {
  window.open(buildWhatsappUrl(text), "_blank", "noopener,noreferrer");
}
